/**
 * Las preferencias de pantalla, recordadas entre visitas.
 *
 * Aca SI es localStorage, al reves que el token de sesion: la regla del
 * proyecto es que la sesion muera con la pestaña --por eso vive en memoria y
 * en sessionStorage-- y estas preferencias tienen que sobrevivirla, porque lo
 * que se pidio es que la eleccion se recuerde entre visitas. Lo que se guarda
 * aqui no es un dato personal ni una credencial: es que capa del mapa mira el
 * usuario y si tiene el menu lateral abierto.
 *
 * Todo va envuelto en try/catch. En Safari en ventana privada `localStorage`
 * existe y lanza al escribir, y en un iframe con cookies de terceros
 * bloqueadas lanza al LEER: una preferencia de interfaz no puede tumbar una
 * pantalla.
 */

export function leerPreferencia(clave: string): string | null {
  try {
    return globalThis.localStorage.getItem(clave)
  } catch {
    return null
  }
}

export function guardarPreferencia(clave: string, valor: string): void {
  try {
    globalThis.localStorage.setItem(clave, valor)
  } catch {
    // Sin sitio donde guardar, la preferencia dura lo que la pestaña.
  }
}

/** Una bandera si/no. Cualquier valor que no sea 'si' o 'no' cae en el de omision. */
export function leerBandera(clave: string, porOmision: boolean): boolean {
  const guardada = leerPreferencia(clave)

  if (guardada === 'si') {
    return true
  }

  if (guardada === 'no') {
    return false
  }

  return porOmision
}

export function guardarBandera(clave: string, valor: boolean): void {
  guardarPreferencia(clave, valor ? 'si' : 'no')
}
